// extracted by mini-css-extract-plugin
module.exports = {"formHeading":"FormHeading_formHeading__32El8","formIcon":"FormHeading_formIcon__2v09s"};